<app-side-top-bar [navigationItems]="navigationItems">
  <main class="issue-sts-credit-note">
    <section class="issue-sts-credit-note-section">
      <header class="header">
        <h2>Emetti Nota di Credito STS</h2>
      </header>

      @if (isLoading) {
        <div class="loading-container">
          <app-loader [size]="'big'"></app-loader>
        </div>
      }

      @if (!isLoading && creditNoteForm) {
        <div class="form-content">
          <form [formGroup]="creditNoteForm" class="credit-note-form">
            <section class="dati-documento">
              <h3>Dati Nota di Credito</h3>
              <div class="document-grid">
                <div class="document-row">
                  <mat-form-field>
                    <mat-label>Tipo</mat-label>
                    <input matInput formControlName="tipo" readonly />
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Numero fattura originale</mat-label>
                    <input
                      matInput
                      formControlName="numero_fattura_originale"
                      readonly
                    />
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Numero</mat-label>
                    <input
                      matInput
                      formControlName="progressivo_numero"
                      [minlength]="3"
                      [maxlength]="3"
                    />
                    @if (
                      creditNoteForm.get("progressivo_numero")?.errors?.[
                        "pattern"
                      ]
                    ) {
                      <mat-error>Il numero deve essere di 3 cifre</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Importo</mat-label>
                    <input
                      matInput
                      type="number"
                      formControlName="importo"
                      min="0.01"
                      step="0.01"
                    />
                    @if (creditNoteForm.get("importo")?.errors?.["min"]) {
                      <mat-error
                        >L'importo deve essere maggiore di zero</mat-error
                      >
                    }
                  </mat-form-field>
                </div>
              </div>
            </section>

            <div class="form-buttons">
              <button
                class="button-white"
                mat-stroked-button
                type="button"
                [disabled]="isSubmitting"
                (click)="onCancel()"
              >
                Annulla
              </button>
              <button
                class="button-white"
                mat-stroked-button
                color="primary"
                type="button"
                [disabled]="isSubmitting"
                (click)="onSubmit()"
              >
                Invia Nota di Credito STS
              </button>
            </div>
          </form>
        </div>
      }
    </section>
  </main>
</app-side-top-bar>
